import { all } from 'redux-saga/effects';
import user from './user/user-sagas';
import menu from './menu/menu-sagas';
import settings from './settings/settings-sagas';
import importSagas from './import/import-sagas';

export default function* rootSaga() {
  yield all([user(), menu(), settings(), importSagas()]);
}
